import auth0 from 'auth0-js'
import jwtDecode from 'jwt-decode'
import Vue from 'vue'
import auth from '@/apis/auth'
import {
  // RESET_STATE,
  HANDLE_AUTHENTICATION_REQUEST,
  HANDLE_AUTHENTICATION_SUCCESS,
  HANDLE_AUTHENTICATION_FAILURE,
  START_CHECKING_SESSION,
  STOP_CHECKING_SESSION,
  LOAD_LAST_SESSION,
  SET_SESSION,
  CLEAR_SESSION,
  UPDATE_USERINFO,
  INIT_AUTH0,
  CHECK_SESSION_REQUEST,
  CHECK_SESSION_SUCCESS,
  CHECK_SESSION_FAILURE,
  SEND_PASSWORDRESET_EMAIL_REQUEST,
  SEND_PASSWORDRESET_EMAIL_SUCCESS,
  SEND_PASSWORDRESET_EMAIL_FAILURE,
  GET_IDTOKEN_IPAUTH_REQUEST,
  GET_IDTOKEN_IPAUTH_SUCCESS,
  GET_IDTOKEN_IPAUTH_FAILURE
} from '../mutation-types'

let initialState = {
  auth0: null,
  checkingSession$t: null,
  accountCreatedAt: null,
  newAccountLogicBeginDate: new Date('2018-11-15T00:00:00.000Z'), // hard-coded
  lastPasswordReset: 'TBD',
  authResult: {
    ip: null,
    ipAuthDealer: null,
    provider: null,
    email: null,
    accessToken: null,
    idToken: null,
    expiresAt: null
  },
  status: {
    handleAuthentication: null,
    checkSession: null,
    sendPasswordResetEmail: null,
    getIDTokenIPAuth: null
  }
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  statusHandleAuthentication: function (state) {
    return state.status.handleAuthentication
  },
  statusCheckSession: function (state) {
    return state.status.checkSession
  },
  statusSendPasswordResetEmail: function (state) {
    return state.status.sendPasswordResetEmail
  },
  statusGetIDTokenIPAuth: function (state) {
    return state.status.getIDTokenIPAuth
  },
  isToResetPasswordAuth0: function (state) {
    return state.lastPasswordReset === 'TBD' ? false : !state.lastPasswordReset
  },
  lastPasswordReset: function (state) {
    return state.lastPasswordReset
  },
  accountCreatedDate: function (state) { // string
    return new Date(state.accountCreatedAt)
  },
  newAccountLogicBeginDate: function (state) { // string
    return state.newAccountLogicBeginDate
  },
  auth0: function (state) {
    return state.auth0
  },
  idToken: function (state) {
    return state.authResult.idToken
  },
  idTokenExpiresAt: function (state) {
    return state.authResult.expiresAt
  },
  idTokenProvider: function (state) {
    return state.authResult.provider
  },
  idTokenIPAuthDealerID: function (state) {
    return state.authResult.ipAuthDealer
  },
  idTokenIPAuthIP: function (state) {
    return state.authResult.ip
  },
  isAuthenticated: function (state) {
    return () => {
      let expiresAt = state.authResult.expiresAt ? state.authResult.expiresAt : 0
      return new Date().getTime() < expiresAt
    }
  },
  isAuthenticatedInCookie: function () {
    return () => {
      let expiresAt = Vue.tool.getCookie('chekt::expires_at') ? Vue.tool.getCookie('chekt::expires_at') : 0
      return new Date().getTime() < expiresAt
    }
  },
  isIdTokenExpired: function (state) {
    let expiresAt = state.authResult.expiresAt ? state.authResult.expiresAt : 0
    const now = new Date().getTime()
    return expiresAt < now
  },
}
// actions
const actions = {
  login: function ({commit, state}) {
    if (!state.auth0) commit('INIT_AUTH0')
    state.auth0.authorize({
      login_hint: Vue.param.options['email'] || Vue.tool.getCookie('chekt::email')
    })
  },
  checkSession: function ({dispatch, commit, state, getters}) {
    // if ID token is not expired, no need to check session
    if (!getters.isIdTokenExpired) return

    commit(CHECK_SESSION_REQUEST)
    if (!state.auth0) commit('INIT_AUTH0')
    return new Promise((resolve, reject) => {
      state.auth0.checkSession({
        // state and nonce should be handled by auth0-js library, so don't need to do that here
      }, function (err, authResult) {
        // console.log('checkSession')
        // console.log(authResult)
        if (err) {
          commit(CHECK_SESSION_FAILURE)
          reject(err)
        } else {
          let expiresIn = commit(SET_SESSION, authResult)
          commit(CHECK_SESSION_SUCCESS)
          resolve(expiresIn)
        }
      })
    })
  },
  handleAuthentication: function ({commit, state}) {
    if (!state.auth0) commit('INIT_AUTH0')
    commit(HANDLE_AUTHENTICATION_REQUEST)
    return new Promise((resolve, reject) => {
      state.auth0.parseHash({
        __enableIdPInitiatedLogin: true // warning CSRF attackable
      }, function (err, authResult) {
        // console.log('handleAuthentication')
        // console.log(authResult)
        if (authResult && authResult.accessToken && authResult.idToken) {
          commit(SET_SESSION, authResult)
          commit(HANDLE_AUTHENTICATION_SUCCESS)
          resolve()
        } else if (err) {
          commit(HANDLE_AUTHENTICATION_FAILURE)
          reject(err)
        } else {
          reject(new Error('no_result'))
        }
      })
    })
  },
  logout: function ({commit, state}) {
    if (Vue.param.getParamValue('ip_auth_dealer')) {
      Vue.tool.redirectToUrl(window.location.origin + window.location.search)
    } else {
      commit(CLEAR_SESSION)
      if (!state.auth0) commit('INIT_AUTH0')
      state.auth0.logout({
        returnTo: window.location.origin + window.location.search,
        clientID: Vue.env.authClientID
      })
    }
  },
  changePassword: function ({commit, state}) {
    if (!state.auth0) commit('INIT_AUTH0')
    commit('SEND_PASSWORDRESET_EMAIL_REQUEST')
    return new Promise((resolve, reject) => {
      state.auth0.changePassword({
        connection: Vue.env.authConnection,
        email: state.authResult.email
      }, function (err, resp) {
        if (err) {
          reject(err)
          commit('SEND_PASSWORDRESET_EMAIL_FAILURE')
        } else {
          resolve(resp)
          commit('SEND_PASSWORDRESET_EMAIL_SUCCESS')
        }
      })
    })
  },
  getUserInfo: function ({commit, state}) {
    return new Promise((resolve, reject) => {
      if (!state.authResult.ipAuthDealer) {
        if (state.auth0) {
          state.auth0.client.userInfo(state.authResult.accessToken, function (err, user) {
            if (err) {
              reject(err)
            } else {
              resolve()
              commit(UPDATE_USERINFO, user)
            }
          })
        } else {
          reject(new Error('auth0 is not initiated'))
        }
      } else {
        resolve()
        Vue.logger.info('getUserInfo: IP auth does\'t have user info')
      }
    })
  },
  getIDTokenIPAuth: function ({commit, state}, {dealerID}) {
    commit(GET_IDTOKEN_IPAUTH_REQUEST)
    let randomString = Vue.tool.randomString(32)
    return new Promise((resolve, reject) => {
      auth.getIDTokenIPAuth(dealerID, randomString).then(
        res => {
          if (res.body.state === randomString) {
            commit(GET_IDTOKEN_IPAUTH_SUCCESS, {
              dealerID: dealerID,
              data: res.body
            })
            resolve()
          } else {
            commit(GET_IDTOKEN_IPAUTH_FAILURE)
            reject(new Error('State doesn\'t match'))
          }
        },
        err => {
          commit(GET_IDTOKEN_IPAUTH_FAILURE)
          reject(err.body)
        }
      )
    })
  }
}

// mutations
const mutations = {
  // [RESET_STATE]: function (state) {
  //   for (let f in state) {
  //     Vue.set(state, f, initialState[f])
  //   }
  // },
  [INIT_AUTH0]: function (state) {
    state.auth0 = new auth0.WebAuth({
      domain: Vue.env.authDomain,
      // audience: Vue.env.authAudience, // it goes RS256 if audience is added.
      clientID: Vue.env.authClientID,
      redirectUri: window.location.origin + '/callback' + window.location.search,
      responseType: 'token id_token', // RH256 requires both access_token and id_token. It uses access_token to validate id_token
      scope: 'openid'
    })
  },
  [START_CHECKING_SESSION]: function (state, timer$f) {
    state.checkingSession$t = timer$f
  },
  [STOP_CHECKING_SESSION]: function (state) {
    if (state.checkingSession$t) {
      clearTimeout(state.checkingSession$t)
      state.checkingSession$t = null
    }
  },
  [HANDLE_AUTHENTICATION_REQUEST]: function (state) {
    state.status = {...state.status, 'handleAuthentication': 'requested'}
  },
  [HANDLE_AUTHENTICATION_SUCCESS]: function (state) {
    state.status = {...state.status, 'handleAuthentication': 'successful'}
  },
  [HANDLE_AUTHENTICATION_FAILURE]: function (state) {
    state.status = {...state.status, 'handleAuthentication': 'failed'}
  },
  [CHECK_SESSION_REQUEST]: function (state) {
    state.status = {...state.status, 'checkSession': 'requested'}
  },
  [CHECK_SESSION_SUCCESS]: function (state) {
    state.status = {...state.status, 'checkSession': 'successful'}
  },
  [CHECK_SESSION_FAILURE]: function (state) {
    state.status = {...state.status, 'checkSession': 'failed'}
  },
  [LOAD_LAST_SESSION]: function (state) {
    let idToken = Vue.tool.getCookie('chekt::id_token')
    let accessToken = Vue.tool.getCookie('chekt::access_token')
    let expiresAt = Vue.tool.getCookie('chekt::expires_at')
    if (idToken && expiresAt) {
      Vue.auth.storeIdTokenToAuthService(idToken)
      state.authResult = {...state.authResult, 'idToken': idToken}
      state.authResult = {...state.authResult, 'expiresAt': expiresAt}
    }
    state.authResult = {...state.authResult, 'accessToken': accessToken}
    Vue.logger.info('LOAD_LAST_SESSION')
  },
  [SET_SESSION]: function (state, authResult) {
    let decodedToken = jwtDecode(authResult.idToken)
    let expiresAt = decodedToken.exp * 1000
    let expiresIn = +decodedToken.exp - +decodedToken.iat
    Vue.tool.setCookie('chekt::access_token', authResult.accessToken)
    Vue.tool.setCookie('chekt::expires_at', expiresAt)
    Vue.tool.setCookie('chekt::id_token', authResult.idToken)
    Vue.auth.storeIdTokenToAuthService(authResult.idToken)
    if (authResult.idTokenPayload instanceof Object) {
      // email
      if (authResult.idTokenPayload.email) {
        Vue.tool.setCookie('chekt::email', authResult.idTokenPayload.email)
        state.authResult = {...state.authResult, 'email': authResult.idTokenPayload.email}
      }
      // last password reset
      state.lastPasswordReset = authResult.idTokenPayload.last_password_reset
      // account created date
      state.accountCreatedAt = authResult.idTokenPayload.created_at
    }
    Vue.logger.info('Session valid for next ' + (expiresIn / 60) + ' minute(s)')
    // console.log(authResult)
    state.authResult = {...state.authResult, 'idToken': authResult.idToken}
    state.authResult = {...state.authResult, 'expiresAt': expiresAt}
    state.authResult = {...state.authResult, 'accessToken': authResult.accessToken}
    return expiresIn
  },
  [CLEAR_SESSION]: function (state) {
    Vue.tool.deleteCookie('chekt::access_token')
    Vue.tool.deleteCookie('chekt::expires_at')
    Vue.tool.deleteCookie('chekt::id_token')
    state.authResult = {...state.authResult, 'email': null}
    state.authResult = {...state.authResult, 'idToken': null}
    state.authResult = {...state.authResult, 'expiresAt': null}
    state.authResult = {...state.authResult, 'accessToken': null}
    state.authResult = {...state.authResult, 'ipAuthDealer': null}
  },
  [UPDATE_USERINFO]: function (state, userInfo) {
    // last password reset
    state.lastPasswordReset = userInfo.last_password_reset
    // account created date
    state.accountCreatedAt = userInfo.created_at
  },
  [SEND_PASSWORDRESET_EMAIL_REQUEST]: function (state) {
    state.status = {...state.status, 'sendPasswordResetEmail': 'requested'}
  },
  [SEND_PASSWORDRESET_EMAIL_SUCCESS]: function (state) {
    state.status = {...state.status, 'sendPasswordResetEmail': 'successful'}
  },
  [SEND_PASSWORDRESET_EMAIL_FAILURE]: function (state) {
    state.status = {...state.status, 'sendPasswordResetEmail': 'failed'}
  },
  [GET_IDTOKEN_IPAUTH_REQUEST]: function (state) {
    state.status = {...state.status, 'getIDTokenIPAuth': 'requested'}
  },
  [GET_IDTOKEN_IPAUTH_SUCCESS]: function (state, {dealerID, data}) {
    try {
      let idToken = data.id_token
      let decodedToken = jwtDecode(idToken)
      let expiresAt = decodedToken.exp * 1000
      let expiresIn = +decodedToken.exp - +decodedToken.iat
      let ip = decodedToken.ip
      if (idToken && expiresAt) {
        Vue.auth.storeIdTokenToAuthService(idToken)
        state.authResult = {...state.authResult, 'ipAuthDealer': dealerID}
        state.authResult = {...state.authResult, 'idToken': idToken}
        state.authResult = {...state.authResult, 'expiresAt': expiresAt}
        state.authResult = {...state.authResult, 'ip': ip}
        Vue.logger.info('IP Auth: Session valid for next ' + (expiresIn / 60) + ' minute(s)')
        state.status = {...state.status, 'getIDTokenIPAuth': 'successful'}
      } else {
        Vue.logger.error('GET_IDTOKEN_IPAUTH_SUCCESS: Failed: Invalid idToken or expiresAt')
        state.status = {...state.status, 'getIDTokenIPAuth': 'failed'}
      }
    } catch (err) {
      Vue.logger.error('GET_IDTOKEN_IPAUTH_SUCCESS: Failed')
      Vue.logger.error(err.message)
      state.status = {...state.status, 'getIDTokenIPAuth': 'failed'}
    }
  },
  [GET_IDTOKEN_IPAUTH_FAILURE]: function (state) {
    state.status = {...state.status, 'getIDTokenIPAuth': 'failed'}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth0.js